export const FEATURE_FLAGS = {
  AGENT_BOTS: 'agent_bots',
  AGENT_MANAGEMENT: 'agent_management',
  ASSIGNMENT_V2: 'assignment_v2',
  AUTO_RESOLVE_CONVERSATIONS: 'auto_resolve_conversations',
  AUTOMATIONS: 'automations',
  CAMPAIGNS: 'campaigns',
  COMPANIES: 'companies',
  WHATSAPP_CAMPAIGNS: 'whatsapp_campaign',
  CANNED_RESPONSES: 'canned_responses',
  CRM: 'crm',
  CUSTOM_ATTRIBUTES: 'custom_attributes',
  INBOX_MANAGEMENT: 'inbox_management',
  INTEGRATIONS: 'integrations',
  LABELS: 'labels',
  MACROS: 'macros',
  HELP_CENTER: 'help_center',
  REPORTS: 'reports',
  TEAM_MANAGEMENT: 'team_management',
  VOICE_RECORDER: 'voice_recorder',
  AUDIT_LOGS: 'audit_logs',
  INBOX_VIEW: 'inbox_view',
  SLA: 'sla',
  CHANNEL_EMAIL: 'channel_email',
  CHANNEL_FACEBOOK: 'channel_facebook',
  CHANNEL_TWITTER: 'channel_twitter',
  CHANNEL_WEBSITE: 'channel_website',
  CUSTOM_REPLY_DOMAIN: 'custom_reply_domain',
  CUSTOM_REPLY_EMAIL: 'custom_reply_email',
  DISABLE_BRANDING: 'disable_branding',
  EMAIL_CONTINUITY_ON_API_CHANNEL: 'email_continuity_on_api_channel',
  INBOUND_EMAILS: 'inbound_emails',
  IP_LOOKUP: 'ip_lookup',
  CONVERSATION_HISTORY: 'conversation_history',
  LINEAR: 'linear_integration',
  WOOCOMMERCE_INTEGRATION: 'woocommerce_integration',
  SHOPIFY_INTEGRATION: 'shopify_integration',
  NOTION_INTEGRATION: 'notion_integration',
  CUSTOM_ROLES: 'custom_roles',
  WAVOIP: 'wavoip',
  CHATWOOT_V4: 'chatwoot_v4',
  CHANNEL_INSTAGRAM: 'channel_instagram',
  CHANNEL_TIKTOK: 'channel_tiktok',
  CONTACT_CHATWOOT_SUPPORT_TEAM: 'contact_chatwoot_support_team',
  WHATSAPP_EVOLUTION: 'whatsapp_evolution',
  WHATSAPP_WAHA: 'whatsapp_waha',
  WHATSAPP_UAZAPI: 'whatsapp_uazapi',
  WHATSAPP_EMBEDDED_SIGNUP: 'whatsapp_embedded_signup',
  INBOX_MIGRATION: 'inbox_migration',
  SAML: 'saml',
  QUOTED_EMAIL_REPLY: 'quoted_email_reply',
  CHAT_ROOMS: 'chat_rooms',
};

export const PREMIUM_FEATURES = [
  // Original premium features
  FEATURE_FLAGS.SLA,
  FEATURE_FLAGS.CUSTOM_ROLES,
  FEATURE_FLAGS.AUDIT_LOGS,
  FEATURE_FLAGS.HELP_CENTER,
  FEATURE_FLAGS.SAML,
  FEATURE_FLAGS.WAVOIP,
  // Ai Focus premium features
  FEATURE_FLAGS.CHANNEL_TIKTOK,
  FEATURE_FLAGS.WHATSAPP_EMBEDDED_SIGNUP,
  FEATURE_FLAGS.WHATSAPP_CAMPAIGNS,
  FEATURE_FLAGS.CHANNEL_WEBSITE,
  FEATURE_FLAGS.VOICE_RECORDER,
  FEATURE_FLAGS.MACROS,
  FEATURE_FLAGS.COMPANIES,
  FEATURE_FLAGS.CUSTOM_ATTRIBUTES,
  FEATURE_FLAGS.CAMPAIGNS,
  FEATURE_FLAGS.CHAT_ROOMS,
];
